export const CURRENT_PAGE = '::current';

export const sportType = {
    1: 'futbal',
    3: 'hokej',
    5: 'basketbal',
    7: 'tenis',
    8: 'lyzovanie',
    11: 'hadzana',
    13: 'volejbal',
    14: 'box',
    15: 'skokynalyziach',
    17: 'cyklokros',
    18: 'modernypatboj',
    19: 'atletika',
    38: 'cyklistika',
    39: 'americkyfutbal',
    44: 'letynalyziach',
    47: 'biatlon',
    48: 'severskakombinacia',
    49: 'curling',
    51: 'krasokorculovanie',
    52: 'sankovanie',
    53: 'snowboarding',
    54: 'boby',
    55: 'rychlokorculovanie',
    56: 'skeleton',
    57: 'akrobatlyzovanie',
    59: 'baseball',
    60: 'veslovanie',
    61: 'stolnytenis',
    62: 'vodnepolo',
    63: 'olympijskehry',
    64: 'plavanie',
    67: 'rugby',
    68: 'futsal',
    70: 'pozemnyhokej',
    71: 'strelba',
    72: 'vzpieranie',
    73: 'vodnyslalom',
    74: 'kanoistika',
    75: 'triatlon',
    76: 'superstar',
    77: 'gol',
    // 78: 'duel',
    80: 'oskar',
    83: 'plazovyfutbal',
    85: 'snooker',
    86: 'hokejbal',
    87: 'motorizmus',
    88: 'sipky',
    89: 'plazovyvolejbal',
    90: 'florbal',
    91: 'bowls',
    92: 'golf',
    93: 'lakros',
    96: 'inlinehokej',
    98: 'plazovahadzana',
    99: 'softball',
    100: 'skokydovody',
    101: 'badminton',
    102: 'jazdectvo',
    104: 'jachting',
    105: 'horskacyklistika',
    106: 'drahovacyklistika',
    107: 'sportovagymnastika',
    108: 'modernagymnastika',
    109: 'cyklistikabmx',
    110: 'synchrplavanie',
    113: 'klasickelyzovanie',
    116: 'australskyfutbal',
    118: 'bandyhokej',
    119: 'olympijskehry',
    120: 'sortrek',
    121: 'sach',
    123: 'salovyfutbal',
    124: 'kriket',
    126: 'parlamentnevolby',
    127: 'prezidentskevolby',
    128: 'vh_dostihy',
    129: 'tenis',
    130: 'cyklistika',
    131: 'futbal',
    132: 'motorizmus',
    133: 'volbapapeza',
    134: 'kickbox',
    135: 'kolky',
    137: 'politika',
    138: 'spolocenskestavky',
    139: 'lukostrelba',
    140: 'xfactor',
    141: 'hlasceskoslovenska',
    142: 'bojovesporty',
    143: 'prviberu',
    144: 'poker',
    // 146: 'highdiving',
    147: 'malyfutbal',
    148: 'squash',
    149: 'esporty',
    150: 'serm',
    151: 'dzudo',
    // 152: 'trampolina',
    // 153: 'zapasenie',
    154: 'taekwondo',
    155: 'dostihy',
    157: 'pool',
    158: 'sportovelezenie',
    163: 'niketv'
};

export const sportTypeDiacritic = {
    1: 'futbal',
    3: 'hokej',
    5: 'basketbal',
    7: 'tenis',
    11: 'hádzaná'
};

export const BET_TIPS = {
    49: '1',
    50: '2',
    51: '12',
    52: '1X',
    53: 'X2',
    88: 'X'
};

export const enum marketCollapse {
    NONE = 'NONE',
    ALL = 'ALL',
    LABEL = 'LABEL'
}
